import { HttpContext, httpResource } from '@angular/common/http';
import { Service, computed, effect, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ResponseApi } from '../../../core/dtos/response-api';
import { HANDLE_HTTP_ERROR_LOCALLY } from '../../../core/http/http-context-tokens';
import { TemaService } from '../../../core/services/tema.service';
import {
  BlocoHomepagePublico,
  secoesDosBlocos,
} from '../homepage/secoes-homepage/secoes-homepage.model';

const RECURSO = `${environment.apiUrl}/sai/cartaservico/publico/padrao-homepage`;

/** O erro fica local: sem o padrão, o portal fica na ordem e na cor padrão, sem alerta ao visitante. */
const ERRO_LOCAL = () => new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true);

/** A resposta de `GET publico/padrao-homepage`. */
export interface PadraoHomepagePublicoResponse {
  desTemaPdh: string | null;
  blocos: BlocoHomepagePublico[];
}

/**
 * O padrão da página inicial que o órgão publica no adm (Padrão de Cores e Ordenação): o
 * tema de cores de todas as páginas e a ordem e a visibilidade das seções da homepage.
 *
 * É raiz e o layout o injeta: uma requisição por carregamento do portal, e o tema chega a
 * qualquer página de entrada. O portal não envia o órgão: o back-end o resolve pelo host.
 *
 * Carregando, com erro ou sem personalização, vale o padrão do portal: todas as seções na
 * ordem de `SECOES_HOMEPAGE` e a cor padrão do `TemaService`.
 */
@Service()
export class PadraoHomepageService {
  private readonly tema = inject(TemaService);

  private readonly padraoApi = httpResource<ResponseApi<PadraoHomepagePublicoResponse>>(() => ({
    url: RECURSO,
    context: ERRO_LOCAL(),
  }));

  /** O `error()` é consultado antes do `value()`, que lança em estado de erro. */
  private readonly padrao = computed<PadraoHomepagePublicoResponse | null>(() => {
    if (this.padraoApi.error() !== undefined) return null;

    return this.padraoApi.value()?.data ?? null;
  });

  /** As seções da homepage na ordem do órgão, sem as que ele ocultou. */
  readonly secoes = computed(() => secoesDosBlocos(this.padrao()?.blocos ?? []));

  constructor() {
    effect(() => this.tema.definirCorOrgao(this.padrao()?.desTemaPdh));
  }
}
